import { Outlet, useLocation, Link, NavLink } from "react-router-dom";
import SellerTopBar from "../components/SellerTopBar";

import {
  House,
  Box,
  Cart,
  Tag,
  BarChart,
  Headset,
  Gear,
} from "react-bootstrap-icons";

export default function SellerDashboard() {
  const location = useLocation();

  const menuItems = [
    { name: "Home", icon: <House />, path: "home" },
    { name: "Catalog", icon: <Box />, path: "catalog" },
    { name: "Orders", icon: <Cart />, path: "orders" },
    { name: "Promotions", icon: <Tag />, path: "promotions" },
    { name: "Analytics", icon: <BarChart />, path: "analytics" },
    { name: "Support", icon: <Headset />, path: "support" },
    { name: "Settings", icon: <Gear />, path: "settings" },
  ];

  // settings sublinks (relative to /dashboard/settings)
  const settingsChildren = [
    { name: "View Your Details", to: "", end: true },
    { name: "Change Password", to: "change-password" },
    { name: "Change Your Details", to: "edit" },
  ];

  // helper: treat settings active when path starts with /dashboard/settings
  const isSettingsActive = location.pathname.startsWith("/dashboard/settings");

  return (
    <div className="min-vh-100 d-flex flex-column bg-light">
      {/* TOP BAR */}
      <SellerTopBar />

      <div className="d-flex flex-grow-1 overflow-hidden">
        {/* ================= DESKTOP SIDEBAR ================= */}
        <aside
          className="d-none d-lg-flex flex-column bg-white border-end p-3"
          style={{ width: 260 }}
        >
          <ul className="nav flex-column gap-1">
            {menuItems.map((item) => {
              const isActive =
                item.path === "settings"
                  ? isSettingsActive
                  : location.pathname === `/dashboard/${item.path}`;

              return (
                <li key={item.name} className="nav-item">
                  <Link
                    to={`/dashboard/${item.path}`}
                    className={`nav-link d-flex align-items-center px-3 py-2 ${
                      isActive
                        ? "fw-semibold text-primary bg-light"
                        : "text-dark"
                    }`}
                    style={{ borderRadius: 8 }}
                  >
                    <span
                      className={`me-2 ${
                        isActive ? "text-primary" : "text-muted"
                      }`}
                    >
                      {item.icon}
                    </span>
                    {item.name}
                  </Link>

                  {/* Render settings sublist under Settings in the sidebar */}
                  {item.path === "settings" && isSettingsActive && (
                    <ul className="nav flex-column ms-3 mt-2">
                      {settingsChildren.map((child) => (
                        <li key={child.name} className="nav-item">
                          <NavLink
                            to={`/dashboard/settings${child.to ? `/${child.to}` : ""}`}
                            end={child.end}
                            className={({ isActive: childActive }) =>
                              `nav-link px-3 py-1 ${childActive ? "text-primary fw-semibold" : "text-muted"}`
                            }
                            style={{ borderRadius: 6 }}
                          >
                            {child.name}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </aside>

        {/* ================= MAIN CONTENT ================= */}
        <main className="flex-grow-1 overflow-auto p-3 p-md-4">
          <Outlet />
        </main>
      </div>

      {/* ================= MOBILE BOTTOM NAV ================= */}
      <nav className="d-lg-none bg-white border-top">
        <div className="d-flex justify-content-around py-2">
          {menuItems.map((item) => {
            const isActive = location.pathname === `/dashboard/${item.path}`;

            return (
              <Link
                key={item.name}
                to={`/dashboard/${item.path}`}
                className={`text-center text-decoration-none ${
                  isActive ? "text-primary fw-semibold" : "text-muted"
                }`}
                style={{ fontSize: 12 }}
              >
                <div className="fs-5">{item.icon}</div>
                {item.name}
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
